import { createStyles, makeStyles } from '@material-ui/core/styles';
import { colorsPalette } from '../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      position: 'relative',
      padding: '24px',
      background: colorsPalette.violetAnalyticsCard,
      boxShadow: `0px 3px 5px ${colorsPalette.black}`,
      borderRadius: 5,
    },
  }),
);

export default useStyles;
